import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import type { postAListingRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { UserDashboardPostAListingPage } from './UserDashboardPostAListingPage';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

// Note: this file is not used by hypernova because it uses
// RequireAuthentication with `loginPathname` pointing to a CMS page,
// which causes an infinite loop
export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof postAListingRoute>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user)
    return idealistRedirect({ request })(
      SIGN_UP_TO_POST_URL_FOR_LOCALE[context.locale],
    );
}

export default function UserDashboardPostAListingHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <UserDashboardPostAListingPage />;
}
